import React from "react";
import { Menubar } from "primereact/menubar";
import { InputText } from "primereact/inputtext";
import { Badge } from "primereact/badge";
import { useNavigate } from "react-router-dom";
import tarushi from "../image/TarushiWN.png";
import {
  RiBook3Fill,
  RiRobot2Line,
  RiComputerLine,
  RiBook2Line,
} from "react-icons/ri";
import { MdLocalHospital, MdWorkOutline, MdStorage } from "react-icons/md";

function VarNavigationBar() {
  const navigate = useNavigate();

  const itemRenderer = (item) => (
    <a className="flex align-items-center p-menuitem-link">
      {typeof item.icon === "string" ? (
        <span className={`${item.icon} icon-size`} />
      ) : (
        <span className="icon-size">{item.icon}</span>
      )}
      <span className="mx-2">{item.label}</span>
      {item.badge && (
        <span>
          <Badge className="ml-auto" value={item.badge} />
        </span>
      )}
      {item.shortcut && (
        <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">
          {item.shortcut}
        </span>
      )}
    </a>
  );

  const items = [
    {
      label: "Home",
      icon: "pi pi-home",
      template: itemRenderer,
      command: () => navigate("/"),
    },
    {
      label: "About",
      icon: "pi pi-info-circle",
      template: itemRenderer,
      command: () => navigate("/about-us"),
    },
    {
      label: "Services",
      icon: "pi pi-cog",
      command: () => navigate("/services"),
      items: [
        {
          label: "NABH/NABC Accreditation",
          icon: <RiBook3Fill />,
          command: () => navigate("/services/nabh-nabl-accreditation"),
          template: itemRenderer,
        },
        {
          label: "Due Diligence",
          icon: <MdLocalHospital />,
          command: () => navigate("/services/due-diligence"),
          template: itemRenderer,
        },
        {
          label: "Quality Assurance",
          icon: <RiRobot2Line />,
          template: itemRenderer,
        },
        {
          label: "HR Recruitment",
          icon: <MdWorkOutline />,
          template: itemRenderer,
        },
        {
          label: "Medical Value Tourism",
          icon: <RiComputerLine />,
          template: itemRenderer,
        },
        {
          label: "TPA Insurance",
          icon: <MdStorage />,
          template: itemRenderer,
        },
        {
          label: "Clinical Data Management (CDM)",
          icon: <MdStorage />,
          template: itemRenderer,
        },
        {
          label: "Hospital Management Information System (HMIS)",
          icon: <RiComputerLine />,
          template: itemRenderer,
        },
        {
          label: "Biomedical Equipment",
          icon: <RiBook2Line />,
          template: itemRenderer,
        },
      ],
    },
    {
      label: "Contact Us",
      icon: "pi pi-envelope",
      template: itemRenderer,
      command: () => navigate("/contact-us"),
    },
  ];

  const start = (
    <div className="mr-2">
      <img alt="logo" src={tarushi} height="80" />
    </div>
  );

  const end = (
    <div className="flex align-items-center mr-2">
      <InputText
        placeholder="Search"
        type="text"
        className="w-7rem sm:w-auto"
      />
    </div>
  );

  return (
    <div>
      <Menubar
        className="card"
        model={items}
        style={{
          borderRadius: "0",
          marginBottom: "0",
        }}
        start={start}
        end={end}
      />
    </div>
  );
}

export default VarNavigationBar;
